



























import { Vue, Prop, Component } from 'vue-property-decorator';
import { PartnerStatus } from '@compassdigital/foodworks.api.ts';
import Card from '@/components/Card/StandardCard/index.vue';
import UserModule from '@/store/modules/user';

@Component({
  components: {
    Card,
  },
})
export default class SubmissionCard extends Vue {
  get userFullname() {
    return UserModule.fullname;
  }

  get partnerStatus() {
    // TODO: REPLACE LOGIC
    // if (UserModule.currentPartner) {
    //   return UserModule.currentPartner.status;
    // }
    return null;
  }

  get title() {
    if (this.partnerStatus === PartnerStatus.awaitPartner) {
      return 'Your submission requires additional action';
    }
    if (this.partnerStatus === PartnerStatus.awaitScout) {
      return 'Your submission is being reviewed';
    }
    return '';
  }

  get summary() {
    if (this.partnerStatus === PartnerStatus.awaitPartner) {
      return 'Theres was an issue with your application, please update and resubmit as soon as possible.';
    }
    if (this.partnerStatus === PartnerStatus.awaitScout) {
      return ' We’re currently reviewing your submission. Your scout will reach out to you as soon as possible.';
    }
    return '';
  }
}
